import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';
import { Alert, Autosave, Modal, Tabs, Toggle, Slideover } from 'tailwindcss-stimulus-components';
// Listes déroulantes cherchables (règle de CLAUDE.md) : le contrôleur vit avec
// ceux de l'admin, on l'enregistre aussi côté public pour le funnel.
import SearchableSelect from '../controllers/searchable_select_controller.js';

// Start Stimulus application
const application = Application.start();

// Configure Stimulus development experience
application.warnings = true;
application.debug = false;
window.Stimulus = application;

// Import and register all TailwindCSS Components
application.register('alert', Alert)
// application.register('autosave', Autosave)
application.register('modal', Modal)
application.register('tabs', Tabs)
application.register('toggle', Toggle)
application.register('slideover', Slideover)
application.register('searchable-select', SearchableSelect)

// Load and register global controllers
registerControllers(
  application,
  import.meta.globEager('../controllers/public/*_controller.js'),
);

// Load and register view_components controllers
registerControllers(
  application,
  import.meta.globEager('../../components/**/*_controller.js'),
);

import TurboMorph from 'turbo-morph';
TurboMorph.initialize(window.Turbo.StreamActions);
